import { render } from "./contract-card-view.vue?vue&type=template&id=4b1bf9b3"
import script from "./contract-card-view.vue?vue&type=script&setup=true&lang=js"
export * from "./contract-card-view.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/contract-card-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b1bf9b3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b1bf9b3', __exports__)) {
    api.reload('4b1bf9b3', __exports__)
  }
  
  module.hot.accept("./contract-card-view.vue?vue&type=template&id=4b1bf9b3", () => {
    api.rerender('4b1bf9b3', render)
  })

}


export default __exports__